import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import useCustomerIsGendered from '~/shared/utils/useCustomerIsGendered';
import { Button, mobile } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const ShopNowButton = styled(Button)`
  ${mobile`
    width: 100%;
  `}
`;

export const AccountInfoEmptyShopNowButton = ({ variant = 'primary' }) => {
  const gender = useCustomerIsGendered();
  const customerShopDestination = gender === 'F' ? '/' : '/mens/showroom';

  return (
    <ShopNowButton href={customerShopDestination} variant={variant}>
      <FormattedMessage defaultMessage="Shop Now" id="global_cta.shop_now" />
    </ShopNowButton>
  );
};

AccountInfoEmptyShopNowButton.propTypes = {
  variant: PropTypes.string,
};
